<template>
  <sfs-base-table
    :key="tableKey"
    :data-provider="$commissionPlansAPI.getCommissionPlans"
    provider-key="commissionPlans"
    :columns="columns"
    :filters="filters"
    :current-page="currentPage"
    :per-page="perPage"
    :show-per-page="showPerPage"
  >
    <template #cell(name)="data">
      <div>{{ data.item.name }}</div>
      <div class="font-size-sm text-secondary">
        <strong>ID: {{ data.item.id }}</strong>
      </div>
    </template>
    <template #cell(rates_by_year)="data">
      <b-table-simple
        class="mb-0 rate-table"
        small
        responsive
      >
        <b-thead>
          <b-tr>
            <b-th>Schedule</b-th>
            <b-th>Rate</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="rateRow in rateItems(data.item.rates_by_year)"
            :key="rateRow.year"
          >
            <b-td>Year {{ rateRow.year }}</b-td>
            <b-td>{{ rateRow.rate | percentFormatFilter }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </template>
    <template #cell(user_id)="data">
      <b-link :to="{ name: 'user', params: { id: data.item.user_id } }">
        {{ data.item.user.name }}
      </b-link>
    </template>
    <template #cell(active)="data">
      <b-badge
        v-if="!data.item.deleted_at"
        variant="success"
      >
        Active
      </b-badge>
      <b-badge
        v-else
        variant="danger"
      >
        Inactive
      </b-badge>
    </template>
    <template #cell(actions)="data">
      <div class="text-nowrap">
        <b-button
          v-if="$can('update', 'CommissionPlan')"
          v-b-modal="`commission-plans-${data.item.id}-edit-modal`"
          size="sm"
          variant="link"
          class="mr-1"
        >
          <i class="fa fa-fw fa-pencil-alt" />
        </b-button>
        <b-button
          v-if="$can('destroy', 'CommissionPlan')"
          v-b-tooltip.hover
          size="sm"
          variant="link"
          :title="toggleActiveTooltipText(!data.item.deleted_at)"
          @click="toggleActive(data.item.id, !data.item.deleted_at)"
        >
          <i
            v-if="!data.item.deleted_at"
            class="fa fa-fw fa-times"
          />
          <i
            v-else
            class="fa fa-undo"
          />
        </b-button>
      </div>
      <edit-modal
        v-if="$can('update', 'CommissionPlan')"
        :key="`commission-plans-edit-modal-${data.item.id}`"
        :value="data.item"
        @on-save="refreshTable"
      />
    </template>
  </sfs-base-table>
</template>

<script>
import EditModal from '@/components/admin/commissionPlans/EditModal.vue';
import tablePropsMixin from '@/mixins/tablePropsMixin';
import { COMMISSION_PLAN_TABLE_DEFAULT_COLUMNS } from '@/constants/commissionPlans';
import { DateTime } from 'luxon';

export default {
  name: 'CommissionPlansTable',
  mixins: [tablePropsMixin],
  components: {
    EditModal,
  },
  props: {
    columns: {
      type: Array,
      default: () => COMMISSION_PLAN_TABLE_DEFAULT_COLUMNS,
    },
  },
  methods: {
    toggleActiveTooltipText(deleted_at) {
      return deleted_at ? 'Deactivate' : 'Reactivate';
    },
    toggleActiveConfirmText(deleted_at) {
        return deleted_at
          ? 'Are you sure you want to deactivate the Commission Plan?'
          : 'Are you sure you want to reactivate the Commission Plan?';
    },
    toggleActive(id, deleted_at) {
      this.$swal({
        text: this.toggleActiveConfirmText(deleted_at),
        preConfirm: () => this.$commissionPlansAPI.update(id, { deleted_at: (deleted_at ? DateTime.now().toISODate() : null ) }),
      }).then((result) => {
        if (result.value) {
          this.refreshTable();
        }
        result.timer;
      });
    },
    rateItems(ratesByYear) {
      const items = [];
      Object.keys(ratesByYear).forEach((year) => {
        items.push({ year: year, rate: ratesByYear[year] });
      });

      return items;
    }
  },
};
</script>

<style scoped>
  .rate-table .table thead {
    color: #373737;
    background-color: #F8F9FA;
  }
</style>
